import { ScheduleQueryParamPairs } from "./schedule-url-helpers";

/** Utility type which, given a key, extracts the type of the value from the provided tuple */
type ExtractValueWithKey<TKey, TObj> = TObj extends [TKey, infer Value] ? Value : never;

/** A type-safe URLSearchParams (which is a class that exists in all browsers), specific to the schedule navigation */
export class ScheduleSearchParams extends URLSearchParams {
    append(...[name, value]: ScheduleQueryParamPairs) {
        super.append(name, value);
    }

    delete(name: ScheduleQueryParamPairs[0]) {
        super.delete(name);
    }

    get<TKey extends ScheduleQueryParamPairs[0]>(name: TKey) {
        return super.get(name) as ExtractValueWithKey<TKey, ScheduleQueryParamPairs>;
    }

    getAll<TKey extends ScheduleQueryParamPairs[0]>(name: TKey) {
        return super.getAll(name) as ExtractValueWithKey<TKey, ScheduleQueryParamPairs>[];
    }

    has(name: ScheduleQueryParamPairs[0]) {
        return super.has(name);
    }

    set(...[name, value]: ScheduleQueryParamPairs) {
        super.set(name, value);
    }

    sort() {
        super.sort();
    }

    toString() {
        return super.toString();
    }

    [Symbol.iterator]() {
        return super[Symbol.iterator]();
    }
}
